(() => {
  const host = document.getElementById('bv-installments');
  if (!host || host.dataset.ready) return;
  host.dataset.ready = 'true';
  const product = JSON.parse(host.querySelector('[data-bvi-product]').textContent);
  const text = JSON.parse(host.querySelector('[data-bvi-text]').textContent);
  const dialog = host.querySelector('dialog');
  const trigger = host.querySelector('[data-bvi-trigger]');
  const rows = host.querySelector('[data-bvi-rows]');
  const status = host.querySelector('[data-bvi-status]');
  const money = new Intl.NumberFormat(host.dataset.locale || 'tr-TR', { style: 'currency', currency: 'TRY' });
  const percent = new Intl.NumberFormat(host.dataset.locale || 'tr-TR', { maximumFractionDigits: 2 });
  const cache = new Map([[String(product.variant.id), product.variant]]);
  let current = product.variant;
  let config;
  let configPromise;
  let requestedId = String(current.id);
  let pending = false;
  let timer;
  const main = () => document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('#MainContent');
  const format = cents => money.format(cents / 100);
  const label = n => n === 1 ? text.single : `${n} ${text.installments}`;
  const calculate = (price, rate) => {
    const total = Number((BigInt(price) * BigInt(10000 + rate.basisPoints) + 5000n) / 10000n);
    return { total, monthly: Math.floor((total + rate.count / 2) / rate.count), difference: total - price };
  };
  const render = () => {
    host.querySelector('[data-bvi-name]').textContent = product.title;
    host.querySelector('[data-bvi-variant]').textContent = current.title === 'Default Title' ? '' : current.title;
    host.querySelector('[data-bvi-price]').textContent = pending ? '—' : format(current.price);
    status.textContent = pending ? text.loading : '';
    rows.replaceChildren();
    if (!config || pending) return;
    const selected = host.querySelector('input[name="bv-card-family"]:checked').value;
    const family = config.families.find(f => f.id === selected);
    host.querySelector('[data-bvi-card-name]').textContent = family.name;
    for (const rate of config.rates) {
      const result = calculate(current.price, rate);
      const tr = document.createElement('tr');
      const values = [label(rate.count), format(result.monthly), format(result.difference), format(result.total)];
      values.forEach((value, index) => {
        const cell = document.createElement(index === 0 ? 'th' : 'td');
        if (index === 0) cell.scope = 'row';
        cell.textContent = value;
        if (index === 2) {
          const small = document.createElement('small');
          small.textContent = rate.basisPoints === 0 ? text.none : `%${percent.format(rate.basisPoints / 100)}`;
          if (rate.basisPoints === 0) small.className = 'bvi-free';
          cell.append(small);
        }
        tr.append(cell);
      });
      rows.append(tr);
    }
  };
  const loadConfig = () => {
    if (!configPromise) configPromise = fetch(host.dataset.configUrl).then(r => {
      if (!r.ok) throw new Error('Installment configuration unavailable');
      return r.json();
    }).then(data => { config = data; render(); return data; }).catch(() => {
      configPromise = null;
      status.textContent = text.error;
    });
    return configPromise;
  };
  const place = () => {
    const scope = main();
    if (!scope) return;
    const target = scope.querySelector('[data-termorad-selected-price]') || scope.querySelector('[id^="price-"]');
    if (target && target.nextElementSibling !== trigger) target.after(trigger);
    if (target) trigger.hidden = false;
  };
  const setVariant = variant => {
    if (!variant || !Number.isSafeInteger(variant.price) || variant.price < 0) return;
    current = variant;
    requestedId = String(variant.id);
    cache.set(requestedId, variant);
    pending = false;
    render();
  };
  const sync = async () => {
    place();
    const scope = main();
    const id = scope?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    if (!id || id === requestedId) return;
    requestedId = id;
    if (cache.has(id)) { setVariant(cache.get(id)); return; }
    pending = true;
    render();
    try {
      const response = await fetch(`${host.dataset.root}variants/${encodeURIComponent(id)}.js`);
      if (!response.ok) throw new Error('Variant unavailable');
      const variant = await response.json();
      cache.set(id, variant);
      if (id === requestedId) setVariant(variant);
    } catch {
      if (id === requestedId) { rows.replaceChildren(); status.textContent = text.error; requestedId = ''; }
    }
  };
  trigger.addEventListener('click', () => {
    sync(); render();
    dialog.showModal();
    document.documentElement.classList.add('bvi-lock');
    loadConfig();
  });
  host.querySelector('[data-bvi-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) {
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  } });
  dialog.addEventListener('close', () => { document.documentElement.classList.remove('bvi-lock'); trigger.focus({ preventScroll: true }); });
  host.addEventListener('change', event => { if (event.target.name === 'bv-card-family') render(); });
  const observer = new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(sync, 70); });
  const scope = main();
  if (scope) observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
  document.addEventListener('change', event => { if (main()?.contains(event.target) && event.target.closest('variant-selects')) { pending = true; render(); clearTimeout(timer); timer = setTimeout(sync, 150); } });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, event => {
    if (String(event.data.sectionId) !== String(main()?.dataset.section)) return;
    if (event.data.variant) setVariant(event.data.variant);
    else { pending = true; render(); status.textContent = text.error; }
    place();
  });
  document.addEventListener('shopify:section:load', place);
  place(); render();
  loadConfig();
})();
